import React from "react";
import PvaraPhase2 from "./PvaraPhase2";

export default function App() {
  return <PvaraPhase2 />;
}